import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-8 lg:py-12`;

const HeadingColumn = tw.div`text-center xl:text-left max-w-lg xl:max-w-none mx-auto xl:mx-0`;
const HeadingTitle = tw.h1`text-3xl sm:text-5xl md:text-6xl lg:text-5xl font-black leading-none`;
const HeadingDescription = tw.p`my-5 lg:my-8 text-base xl:text-xl text-gray-700`;

const Break = styled.div`
    ${tw`my-4`}
`;

export default () => {
    const { t } = useTranslation();

    return (
        <Container>
            <Content>
                <HeadingColumn>
                    <HeadingDescription>{t("aboutPage.paragraph")}</HeadingDescription>
                </HeadingColumn>
            </Content>
        </Container>
    );
};
